import { jsPDF } from "jspdf";
import { logoBase64 } from "@/utils/pdfLogo";
import { inject } from "vue";

export default function pdfGenerateHandler() {
  const moment = inject("$moment");

  const exportPDF = (membername, item) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const bottomMargin = 20;
    let pageCount = 1;

    // --- HEADER FOR PAGE 1 ---
    const addHeader = () => {
      const logoWidth = 90;
      const logoHeight = 22;
      const logoX = (pageWidth - logoWidth) / 2;

      // ✅ Convert PNG to JPEG + use FAST mode (smaller size)
      doc.addImage(logoBase64, "JPEG", logoX, 10, logoWidth, logoHeight, "", "FAST");

      // Doctor Info
      doc.setFont("helvetica", "normal");

      doc.setFontSize(13);
      doc.text(item[0].doctor_name, pageWidth / 2, 40, { align: "center" });

      doc.setFontSize(11);
      doc.text(item[0].specialization, pageWidth / 2, 47, { align: "center" });

      // Prescription Title
      doc.setFont("helvetica", "bold");
      doc.setFontSize(17);
      doc.text("P  R  E  S  C  R  I  P  T  I  O  N", pageWidth / 2, 68, {
        align: "center",
      });

      // Patient Info
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      doc.text(`Patient Name: ${item[0].membername}`, 10, 85);
      doc.text(
        `Date: ${moment(item[0].created_at).format("LL") || "July 03, 2025"}`,
        pageWidth - 10,
        85,
        { align: "right" }
      );
      doc.text(`Birthdate: ${moment(item[0].birthdate).format("LL")}`, 10, 95);

      // RX Symbol
      doc.setFont("helvetica", "bold");
      doc.setFontSize(32);
      doc.text("R", 10, 112);
      doc.setFontSize(28);
      doc.text("x", 18, 112);
    };

    // --- HEADER FOR PAGE 2+ ---
    const addContinuationHeader = () => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text("PRESCRIPTION CONTINUATION", pageWidth / 2, 25, {
        align: "center",
      });
      doc.setDrawColor(150);
      doc.setLineWidth(0.3);
      doc.line(10, 30, pageWidth - 10, 30);
    };

    // --- FOOTER (Page Numbers) ---
    const addFooter = () => {
      const footerText = `Page ${pageCount}`;
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(footerText, pageWidth / 2, pageHeight - 10, { align: "center" });
    };

    // Start: Page 1 header
    addHeader();

    // --- CONTENT LOOP ---
    let y = 130;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);

    item.forEach((pres) => {
      if (y + 35 > pageHeight - bottomMargin) {
        addFooter();
        doc.addPage();
        pageCount++;
        addContinuationHeader();
        y = 45;
      }

      doc.text(`${pres.generic_name} (${pres.brand_name})`, 25, y);
      y += 7;

      doc.setFontSize(11);
      doc.text(
        `${pres.dose} | #${pres.quantity} | for ${pres.number_of_days} day(s)`,
        30,
        y
      );
      y += 7;

      doc.text(`SIG: ${pres.sig}`, 30, y);
      doc.setFontSize(12);
      y += 14;
    });

    // --- SIGNATURE ---
    if (y + 40 > pageHeight - bottomMargin) {
      addFooter();
      doc.addPage();
      pageCount++;
      addContinuationHeader();
      y = 70;
    }

    const signatureY = Math.min(y + 35, pageHeight - 55);
    const lineWidth = 80;
    const marginRight = 15;
    const lineX = pageWidth - lineWidth - marginRight;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text(item[0].doctor_name, lineX + lineWidth / 2, signatureY, {
      align: "center",
    });

    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(
      `License No: ${item[0].license_number}`,
      lineX + lineWidth / 2,
      signatureY + 8,
      { align: "center" }
    );

    doc.text(
      `PTR No: ${item[0].ptr_number}`,
      lineX + lineWidth / 2,
      signatureY + 14,
      { align: "center" }
    );

    // Final Footer
    addFooter();

    // --- SAVE WITH LOWER QUALITY ---
    // FAST mode already compresses the image; now save as blob for smaller output
    doc.save(`PRESCRIPTION_${item[0].transactionid}.pdf`);
  };

  return { exportPDF };
}
